import Vue from 'vue';
import CookieAlert from '~scripts/components/vue/cookie-alert-ai/CookieAlert.vue';

if (window.region === 'ai') {
  new Vue({
    el: '#CookieAiVue',
    name: 'CookieAi',
    components: {
      CookieAlert,
    },
  });
}
